import React, { useState, useEffect, useCallback, useRef } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { SelectPicker, DatePicker, Drawer, Placeholder, Whisper, Button, Popover, Message, useToaster, Tooltip, Input, Modal } from "rsuite";
import 'rsuite/SelectPicker/styles/index.css';
import { Link } from "react-router-dom";
import 'aos/dist/aos.css';
import AOS from 'aos';
import debounce from 'lodash.debounce';
import IconDelete from "../images/deleteBG.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";

import icon_Asc from "../images/Asc.svg";
import icon_Desc from "../images/Desc.svg";

import icon1_Asc from "../images/Asc.svg";
import icon1_Desc from "../images/Desc.svg";

import icon2_Asc from "../images/Asc.svg";
import icon2_Desc from "../images/Desc.svg";

import icon3_Asc from "../images/Asc.svg";
import icon3_Desc from "../images/Desc.svg";

import iconArrowDrop from "../images/iconArrowDrop.svg";
import Icon_info from "../images/iconInfo.svg";
import mockData from "../sample/mockData.json";

import iconUS from "../images/flag/usa.svg";
import iconIN from "../images/flag/india.svg";
import iconBangla from "../images/flag/bangladesh.svg";
import iconUAE from "../images/flag/uae.png";
import iconsaudi from "../images/flag/saudi.svg";
import iconPakistan from "../images/flag/pakistan.svg";
import iconUK from "../images/flag/uk.svg";
import iconQatar from "../images/flag/qatar.svg";
import iconkuwait from "../images/kuwait.svg";
import iconbahrain from "../images/bahrain.svg";
import iconUSA from "../images/flag/usa.svg";

import iconWhatsapp from "../images/contact/Whatsapp.svg";
import iconMail from "../images/contact/mail.svg";
import iconPhone from "../images/contact/phone.svg";
import iconSMS from "../images/contact/MSG.svg";
import iconTelegram from "../images/contact/telegram.svg";
import iconZoom from "../images/contact/zoom.svg";

import iconGoogle from "../images/contact/google.svg";
import iconTwitter from "../images/contact/twitter.svg";
import iconNewsletter from "../images/contact/newsletter.svg";
import IconEye from "../images/iconEye.svg";

import { parsePhoneNumberFromString } from 'libphonenumber-js';
import IconRefresh from "../images/iconRefresh.svg";
import { encryptData, decryptData } from "./cryptoUtil";
import { CircleFlag } from 'react-circle-flags';

import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'

function WaitingList() {

  const [tabName, setTabName] = useState('Waitlist ');

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const toast = useToast();
  const toastIdRef = React.useRef();


  const orderData = ['ASC', 'DESC'].map(
    item => ({ label: item, value: item })
  );

  const CBAStatus = ['Pass', 'Fail'].map(
    item => ({ label: item, value: item })
  );

  const statusData = [
    { label: 'Publish', value: true },
    { label: 'UnPublish', value: false },
    { label: 'Both', value: '' }
  ];

  useEffect(() => {
    AOS.init();
  }, []);

  const abortControllerRef = useRef(null);
  const [globalLoading, setGlobalLoading] = useState(true); // State to manage loading state
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const [pageRange, setPageRange] = useState("20");
  const [reportdata, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const [countryCode, setCountryCode] = useState();
  const [complianceId, setComplianceId] = useState("");
  const [cbaStatus, setCbaStatus] = useState("");

  const [orderBy, setOrderBy] = useState("id"); // default orderBy
  const [order, setOrder] = useState("DESC"); // default order


   const [investmentamount, setInvestmentamount] = useState(0);
    const [investmentFrom, setInvestmentFrom] = useState(0);
    const [investmentTo, setInvestmentTo] = useState(0);

  const [statusId, setStatusId] = useState(0);
  const [searchInput, setSearchInput] = useState("");

  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const [CMPTminValue, setCMPTMinValue] = useState("");
  const [CMPTmaxValue, setCMPTMaxValue] = useState("");

  const [NCMPTminValue, setNCMPTMinValue] = useState("");
  const [NCMPTmaxValue, setNCMPTMaxValue] = useState("");

  const [DBFTminValue, setDBFTMinValue] = useState("");
  const [DBFTmaxValue, setDBFTMaxValue] = useState("");

  const [IntrestminValue, setIntrestMinValue] = useState("");
  const [IntrestmaxValue, setIntrestMaxValue] = useState("");

  const [DEBTminValue, setDEBTMinValue] = useState("");
  const [DEBTmaxValue, setDEBTMaxValue] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);

  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = sessionStorage.getItem("userId");
  const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;


  const [errorMessage, setErrorMessage] = useState('');
  const [messageType, setMessageType] = useState(null); // success, error, info
  const [assetClassData, setAssetClassData] = useState([]);
  const [searchAsset, setSearchAsset] = useState("Equity");

  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);


  const handleIconClick = (columnName) => {
    // Toggle between ascending and descending icons

    setOrderBy(columnName);

    switch (columnName) {
      case "total_holdings":
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
      case "total_uncovered":
        setIsAscending2(!isAscending2);
        setOrder(isAscending2 ? "DESC" : "ASC");
        break;
      case "total_cover":
        setIsAscending1(!isAscending1);
        setOrder(isAscending1 ? "DESC" : "ASC");
        break;
      default:
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
    }

  };
   const abortControllerRefGlobal = useRef(null);


  const fetchGlobalReport = async () => {

    setGlobalLoading(true);

    // Cancel the previous request if any
    if (abortControllerRefGlobal.current) {
      abortControllerRefGlobal.current.abort();
    }

     // Create a new AbortController for the current request
     const controller = new AbortController();
     abortControllerRefGlobal.current = controller;


    try {
    
      const apiUrl = `${apiEndPoint}/WaitingList`;
      const requestData = encryptData({
        data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          q: searchInput || "",
          order: order,
          country: countryCode || "",
          orderBy:orderBy,
          investment_from:investmentFrom,
          investment_to:investmentTo,
        }
      });


      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: requestData,
        signal: controller.signal
      });
      
      const jsonData = await response.json();
       const decrypted = decryptData(jsonData);
       console.log(decrypted);
       
      if (decrypted.status == "success") {
        setGlobalLoading(false);
        setReportCount(decrypted.count);
        setReportData(decrypted.data);
      } else {
        setGlobalLoading(false);
          setReportCount(decrypted.count);
        setReportData(decrypted.data);
        //toastIdRef.current = toast({ description: decrypted.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        return false;
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("GLobal Request cancelled");
      }
      else{
      setGlobalLoading(false);
      toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });

    }
      return false;
    }
  };


  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 1000),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, countryCode,pageRange,investmentFrom]); // Regular effect for other dependencies


  const handleSearch = (event) => {
    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };


  const [customPaginationValue, setCustomPaginationValue] = useState("");

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 1000), // Delay of 500ms (half a second)
    []
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };


  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;

    } else {

      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav aria-label="..." id='pagination_row' style={{ alignItems: 'center', justifyContent: 'space-between', background: '#FFF', paddingTop: 0, paddingBottom: 0, zIndex: 3 }}>
        <div className='totalRecords'>
          Total Records :  {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: 'none' }}>

          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker onChange={handlePagelimit} cleanable={false}
              value={pageRange}
              placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height: 35, display: 'flex', alignItems: 'center', borderRadius: 5, border: '1px solid #A1B9ED' }} />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{ marginLeft: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map(page => (
            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
              <a
                className="page-link" href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{ marginRight: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li className="page-item" style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}

              style={{
                padding: '0px 10px',
                color: '#878787',
                fontSize: 16,
                borderRadius: 5,
                border: '1px solid #A1B9ED',
                width: 60,
                height: 35,
                textAlign: 'center'
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };





  // PAGINATION
  const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
  );

  const handleClearFilters = () => {
    setCurrentPage(1);
    setSearchInput("");
    setSearchAsset("");
    setCountryCode("");
    setStatusId("");
    setComplianceId("");
    setOrder("");
    setMinValue("");
    setMaxValue("");
    setCMPTMinValue("");
    setCMPTMaxValue("");
    setNCMPTMinValue("");
    setNCMPTMaxValue("");
    setDBFTMinValue("");
    setDBFTMaxValue("");
    setIntrestMinValue("");
    setIntrestMaxValue("");
    setDEBTMinValue("");
    setDEBTMaxValue("");
  };


  const handleAssetClass = (value) => {
    setSearchAsset(value);
    setCurrentPage(1); // Reset to the first page for new search
  };




  const handleCountryChange = (value) => {
    setCurrentPage(1);
    setCountryCode(value);
  };





  const handleStatusChange = (value) => {
    setStatusId(value);
  };

  const handleComplianceChange = (value) => {
    setCurrentPage(1);
    setComplianceId(value);
  };

  const handleCBAChange = (value) => {
    setCurrentPage(1);
    setCbaStatus(value);
  };

  const handleorderChange = (value) => {
    setCurrentPage(1);
    setOrder(value);
  };






  const [openDeletePopover, setOpenDeletePopover] = useState(null);
  const [publishSymbol, setPublishSymbol] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = (item) => {
    // Toggle the popover visibility for the specific item
    setPublishSymbol(item.Symbol)
    if (openDeletePopover === item.id) {
      setOpenDeletePopover(null); // Close the popover if it's already open
    } else {
      setOpenDeletePopover(item.id); // Open the popover
    }
  };

  // // Function to handle deletion confirmation
  // const handlePublishConfirm = (Symbol) => {


  //     console.log(`Publish report with Symbol: ${Symbol}`);
  //     setOpenDeletePopover(null); // Close the popover after confirmation
  // };

  const handlePublishConfirm = (item) => {
    // console.log(`Publish report with Symbol: ${Symbol}`);

    // Prepare the data to be sent in the API request
    const requestData = {
      data: {
        user_id: userid, // Replace with actual user_id if needed
        symbol: item.Symbol, // Use the symbol passed to the function
        publish: item.Published ? "false" : "true"
      }
    };



    setOpenDeletePopover(null); // Close the popover after confirmation
  };


  const handleCheckboxChange = (e, item) => {
    setPublishSymbol(item.Symbol)
    //e.stopPropagation(); // Prevents the event from bubbling up
    // Handle the checkbox change here
    // You can check e.target.checked to see if it's checked or unchecked
  };


  const [open, setOpen] = useState(false);
  const [CMPTopen, setCMPTOpen] = useState(false);
  const [NCMPTopen, setNCMPTOpen] = useState(false);
  const [DBFTopen, setDBFTOpen] = useState(false);
  const [Intrestopen, setIntrestOpen] = useState(false);
  const [DEBTopen, setDEBTOpen] = useState(false);

  //const toggleDropdown = () => setOpen(!open); // Toggle dropdown visibility
  const preventClose = (e) => e.stopPropagation();



  const hideMessage = () => {
    setMessageType(null);
  };

  // Error Message

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 5000);
    };

    switch (messageType) {
      case 'success':
        return (
          <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10, zIndex: 999 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_success'>
                <div className='icon_error_msg_inner Icon_success_inner'>
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_success_text'>
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'error':
        return (
          <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10, zIndex: 999 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_error'>
                <div className='icon_error_msg_inner Icon_error_inner'>
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_error_text'>
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'info':
        return (
          <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_info'>
                <div className='icon_error_msg_inner Icon_info_inner'>
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_info_text'>
                <h5>Info</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };



  // MODAL
  const [filterDate, setFilterDate] = useState(null);
  const [EditModalOpen, setEditModalOpen] = useState(false);
  const [editModalETFName, setEditModalETFName] = useState("");
  const [editModalETFSymbol, setEditModalSymbol] = useState("");
  const etfModelCommentRef = useRef(null);
  const [etfModelPublicComment, setEtfModelPublicComment] = useState("");
  const [etfModelPrivateComment, setEtfModelPrivateComment] = useState("");
  const [isModalETFLoading, setIsModalETFLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const handleEditModalOpen = (item) => {
    setEditModalETFName(item.ETF_Name);
    setEditModalSymbol(item.Symbol);

    if (item.is_manual_set === "1") {
      setSelectedStatus(item.Compliance_status);
      // Update the textarea's value
      setEtfModelPublicComment(item.manual_public_msg || "");
      setEtfModelPrivateComment(item.is_manual_set_msg || "");
    }
    else {
      setSelectedStatus("");
      setEtfModelPublicComment(""); // Clear the comment if not manual set
      setEtfModelPrivateComment("");
    }

    setEditModalOpen(true);
  }
  const handleEditModalClose = () => setEditModalOpen(false);

  // const StatusData = ['Compliant', 'Non- Compliant', 'Doubtful', 'Uncovered'].map(
  //     item => ({ label: item, value: item })
  // );
  const StatusData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: { 'Compliant': 'COMPLIANT', 'Non- Compliant': 'NON_COMPLIANT', 'Doubtful': 'QUESTIONABLE', 'Uncovered': 'NOT_UNDER_COVERAGE' }[item] }));

 useEffect(() => {
     const fetchCountryList = async () => {
       const url = `${apiEndPoint}/country_master`;
       const payload = encryptData({
         data: {
           user_id: userid // Replace with the actual user_id if dynamic
         }
       });
 
       try {
         const response = await fetch(url, {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: payload,
         });
 
         if (!response.ok) {
           throw new Error('Network response was not ok');
         }
 
         const responseData = await response.json();
         //const data = responseData.data; // Flatten the response
         const data = decryptData(responseData);
         const formattedCountryData = data.data.map((country) => ({
           label: country.country_name,
           value: country.country_name,
         }));
 
         setCountryData(formattedCountryData);
 
       } catch (error) {
         
         toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
         return false;
       }
     };
 
     fetchCountryList();
   }, []);
  const MembersData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: item }));

   const InvestmentAmountData = [
    '$0 - $10,000',
    '$10,000 - $20,000',
    '$20,000 - $30,000',
    '$40,000 - $50,000',
    '$50,000+',
  ].map(item => ({ label: item, value: item }));

  const SharesData = [
    '0 - 100',
    '101 - 500',
    '501 - 1,000'
  ].map(item => ({ label: item, value: item }));

  const InvestorTypeData = ['Social Media', 'Referral', 'Email', 'Search', 'Other'].map(item => ({ label: item, value: item }));

  const StatusData1 = ['Committed', 'Funded', 'Interest Express', 'Cancelled', 'Completed'].map(item => ({ label: item, value: item }));


  useEffect(() => {
    if (etfModelCommentRef.current) {
      etfModelCommentRef.current.value = etfModelPublicComment;
    }
  }, [etfModelPublicComment]);



 const handleInvestmentChange = (value) => {
  if (!value) {
    setInvestmentamount(null);
    setInvestmentFrom(null);
    setInvestmentTo(null);
    return;
  }
  
  setInvestmentamount(value);

  // Remove $ and +, then split by '-'
  const cleanedValue = value.replace(/\$/g, '').replace(/\+/g, '').split('-');

  let investmentFrom = null;
  let investmentTo = null;

  if (cleanedValue.length === 2) {
    investmentFrom = parseInt(cleanedValue[0].replace(/,/g, '').trim(), 10);
    investmentTo = parseInt(cleanedValue[1].replace(/,/g, '').trim(), 10);
  } else {
    // For something like "$50,000+" → just one value
    investmentFrom = parseInt(cleanedValue[0].replace(/,/g, '').trim(), 10);
    investmentTo = null;
  }

  console.log('investmentFrom : ' + investmentFrom);
  console.log('investmentTo : ' + investmentTo);

  // Set your state values
  setInvestmentFrom(investmentFrom);
  setInvestmentTo(investmentTo);
};


  const handleManualSave = async () => {

    if (!selectedStatus) {
      
      toastIdRef.current = toast({ description: "Please select new compliance status", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    }

    if (!etfModelPrivateComment) {
      
      toastIdRef.current = toast({ description: "Please add a Private comment before submitting", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });

      return false;
    }




  };

  const handleManualReset = async () => {


    setIsModalETFLoading(true);


  };

  const handleFilterDateChange = (value) => {
    setCurrentPage(1);


    setFilterDate(value);
  };



  const handleETFStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption); // Update selectedPeriod state with the selected option
  };

  const triggerRef = React.useRef();
  const openUncovered = () => triggerRef.current.openUncovered();
  const closeUncovered = () => triggerRef.current.closeUncovered();

  // TRUNCATE
  function truncateText(text, maxLength = 14) {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }


  // REODER DRAG COLUMNS
  const [columnOrder, setColumnOrder] = useState([
    "Waitlist ID",
    "Full Name",
    "Email Address",
    "Phone Number",
    "Country of Residence",
    "Local Time",
    "Preferred Language",
    "Preferred Contact Method",
    "Opt-In Consent",
    "Investment Interest Amount",
    "Estimated Investment Timeline",
    "Accredited Investor Status",
    "Investor Type",
    "Investment Likelihood Score",
    "Platform User Match",
    "App/Web Usage Detected",
    "Subscription Tier at Submission",
    "Subscription Tier Duration (Days)",
    "Platform Registration Date",
    "Lead Owner (IR Rep)",
    "Lead Status",
    "Priority Level",
    "IR Tags (Custom Labels)",
    "IR Notes",
    "Contact History Log",
    "Last Contacted Date",
    "Created At",
    "Last Updated At",
    "UTM Source",
    "UTM Campaign",
    "UTM Medium",
    "Referral Code",
  ]);

  const [draggedColumn, setDraggedColumn] = useState(null);

  const handleDragStart = (e, col) => {
    setDraggedColumn(col);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#FFD791";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = col;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // const handleDrop = (e, targetCol) => {
  //   e.preventDefault();
  //   const fromIndex = columnOrder.indexOf(draggedColumn);
  //   const toIndex = columnOrder.indexOf(targetCol);

  //   if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

  //   const newOrder = [...columnOrder];
  //   const [moved] = newOrder.splice(fromIndex, 1);
  //   newOrder.splice(toIndex, 0, moved);

  //   const thElements = document.querySelectorAll("th");
  //   const tdElements = document.querySelectorAll("tbody tr");

  //   // FLIP: First — Get starting positions
  //   const firstPositions = {};
  //   columnOrder.forEach((key) => {
  //     const th = document.querySelector(`th[data-column-id="${key}"]`);
  //     if (th) firstPositions[key] = th.getBoundingClientRect().left;
  //   });

  //   setColumnOrder(newOrder); // Update DOM

  //   // Wait for re-render
  //   requestAnimationFrame(() => {
  //     // Animate headers (FLIP)
  //     newOrder.forEach((key) => {
  //       const th = document.querySelector(`th[data-column-id="${key}"]`);
  //       const oldX = firstPositions[key];
  //       if (!th || oldX === undefined) return;

  //       const newX = th.getBoundingClientRect().left;
  //       const dx = oldX - newX;

  //       if (dx !== 0) {
  //         th.style.transform = `translateX(${dx}px)`;
  //         th.classList.add("animating");

  //         requestAnimationFrame(() => {
  //           th.style.transform = "";
  //         });

  //         setTimeout(() => {
  //           th.classList.remove("animating");
  //         }, 400);
  //       }
  //     });

  //     // Animate movedColumn cells
  //     const movedColumn = draggedColumn; // dynamically get the dragged column id
  //     const cells = document.querySelectorAll(`[data-column-id="${movedColumn}"]`);
  //     cells.forEach((cell) => {
  //       void cell.offsetWidth; // force reflow to restart animation
  //       cell.classList.add("column-drop-animate");
  //     });

  //     setTimeout(() => {
  //       cells.forEach((cell) => {
  //         cell.classList.remove("column-drop-animate");
  //       });
  //     }, 850);


  //   });




  //   setDraggedColumn(null);
  // };


  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow drop
  };

  // 🟩 Drag end
  const handleDragEnd = () => {
    setDraggedColumn(null);
  };

  const handleDrop = (e, targetColumnKey) => {
    e.preventDefault();

    const draggedIndex = columnOrder.indexOf(draggedColumn);
    const targetIndex = columnOrder.indexOf(targetColumnKey);

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn(null);
      return;
    }

    // Temporarily disable scrollbar during animation
    const tableContainer = document.querySelector(".table").closest("div");
    if (tableContainer) {
      tableContainer.style.overflowY = "hidden";
    }

    const newColumnOrder = [...columnOrder];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder(newColumnOrder);
    setDraggedColumn(null);
    // saveColumnOrder(newColumnOrder);

    // Apply drop animation with performance optimizations
    requestAnimationFrame(() => {
      // Find all cells with the movedColumn's data-column-id
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn}"]`
      );

      // Get current table height to lock it during animation
      const table = document.querySelector("table");
      const tableHeight = table.offsetHeight;
      table.style.height = `${tableHeight}px`;

      cells.forEach((cell) => {
        // Force reflow to ensure animation restarts
        void cell.offsetWidth;
        cell.classList.add("column-drop-animate");
      });

      // Cleanup after animation completes
      setTimeout(() => {
        cells.forEach((cell) => {
          cell.classList.remove("column-drop-animate");
        });

        // Release table height constraint
        table.style.height = "";

        // Re-enable vertical scrolling if needed
        if (tableContainer) {
          tableContainer.style.overflowY = "";
        }

        // Optional: Highlight the table
        table.classList.add("table-highlight-column");
        setTimeout(() => {
          table.classList.remove("table-highlight-column");
        }, 600);
      }, 850); // Slightly longer than animation duration
    });
  };

  const [open2, setOpen2] = useState(false);

  const handleOpenDrawer = () => setOpen2(true);
  const handleCloseDrawer = () => setOpen2(false);


  function formatPhoneNumberGlobal(rawNumber) {
  const phoneNumber = parsePhoneNumberFromString(rawNumber);
  return phoneNumber ? phoneNumber.formatInternational() : rawNumber;
}

const getTimeForTimezone = (timezone) => {
  if (!timezone) return "N/A";

  return new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(new Date());
};

// New component to show continuously updating time
const LiveTimeCell = ({ timezone }) => {
  const [time, setTime] = useState(getTimeForTimezone(timezone));

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeForTimezone(timezone));
    }, 1000); // update every second

    return () => clearInterval(interval); // cleanup
  }, [timezone]);

  return <td>{time}</td>;
};


  return (
    <>
      <Sidebar />
      <ChakraProvider resetCSS={false}> <Wrap> </Wrap> </ChakraProvider>
      <div id='header'>
        {renderMessage()}
        <div className='logo'>
          <div className='logo_icon'>
            <img src={Logo} />
          </div>
          <div className='brand_name'>Waitlist </div>
        </div>

        <div className='header_table_filter'>
          <div className='searchfield'>
            <button className='btn_search'><i className='icon-search2'></i></button>
            <input type='text' className='filter_searchfield' placeholder='Search' onChange={handleSearch} value={searchInput} />
          </div>



          <div className="dropdown_style filter_by_country">
            <SelectPicker
              data={countryData}
              searchable={true}
              style={{ width: 170 }}
              placeholder="Filter by Country"
              onChange={handleCountryChange}
              value={countryCode}
            />
          </div>

         <div className='dropdown_col_filter dropdown__select'>
                     <SelectPicker
                       data={InvestmentAmountData}
                       searchable={false}
                       style={{ width: 180 }}
                       placeholder="Select Investments"
                       onChange={handleInvestmentChange}
                       value={investmentamount}
                     />
                   </div>

          {/* <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={InvestorTypeData}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Source"
              onChange={handleCBAChange}
              value={cbaStatus}
            />
          </div> */}

          <div className='dropdown_col_filter dropdown__select'>
            <DatePicker
              oneTap
              style={{ width: 160 }}
              placeholder="Choose Date"
              format="dd-MM-yyyy"
              value={filterDate}
              onChange={handleFilterDateChange}
            />
          </div>



          {/* <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="All Compliance statuses"
                    />
            </div>
            <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="Both Publish Statuses"
                    />
            </div> */}

          <a href='javascript:void(0)' className="btn_clear_filter" style={{ textDecoration: "none" }} onClick={handleClearFilters}>Clear Filters</a>
        </div>
      </div>
      <div className="container-fluid content pb-5">

        <div className='company_table_list' data-aos="fade-up" data-aos-duration="800">

          {globalLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}

          {/* Table */}
          {!globalLoading && (
            <>
              <div className='table-responsive clsPagingWrap'>
                <table className='table table__iri__sticky'>
                  <thead>
                    <tr>
                      {columnOrder.map((col) => {
                        if (col === "Waitlist ID") {
                          return (
                            <th className='sticky-col left-col-1 waitlist_id_col' key={col}>
                                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span>Waitlist ID</span> <Button className='btn__refresh_header' onClick={fetchGlobalReport}><img src={IconRefresh} /></Button></div></th>
                          );
                        }
                        if (col === "Full Name") {
                          return (
                            <th className='sticky-col left-col-2' key={col}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <span>Name</span>
                                <Button className='btn__cell_show' onClick={handleOpenDrawer}><img src={IconEye} /></Button>
                              </div>
                            </th>
                          );
                        }
                        if (col === "Email Address") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}><div  className='cls_cell_Flex'>
                                                              <span>Email</span>
                                                            </div>
                              
                              </th>
                          );
                        }
                        if (col === "Phone Number") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}> <div className='cls_cell_Flex'>
                                                              <span>Phone</span>
                                                              
                                                            </div></th>
                          );
                        }
                        if (col === "Country of Residence") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Country of Residence</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Residence Country</th>
                            </Whisper>
                          );
                        }
                        if (col === "Local Time") {
                          return (
                            
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Local Time</th>
                          
                          );
                        }
                        if (col === "Preferred Language") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Preferred Language</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Language</th>
                            </Whisper>
                          );
                        }
                        if (col === "Preferred Contact Method") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Preferred Contact Method</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Contact Method</th>
                            </Whisper>
                          );
                        }
                        if (col === "Opt-In Consent") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Opt-In Consent</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",

                                }}>Consent</th>
                            </Whisper>
                          );
                        }
                        if (col === "Investment Interest Amount") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investment Interest Amount</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Investment</th>
                            </Whisper>
                          );
                        }
                        if (col === "Estimated Investment Timeline") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Estimated Investment Timeline</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Timeline</th>
                            </Whisper>
                          );
                        }
                        if (col === "Accredited Investor Status") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Accredited Status</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Accredited</th>
                            </Whisper>
                          );
                        }
                        if (col === "Investor Type") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>Investor Type</th>
                          );
                        }
                        if (col === "Investment Likelihood Score") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investment Likelihood Score</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Likelihood Score</th>
                            </Whisper>
                          );
                        }
                        if (col === "Platform User Match") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Platform User Match</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>User Match</th>
                            </Whisper>
                          );
                        }
                        if (col === "App/Web Usage Detected") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>App/Web Usage Detected</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Usage Detected</th>
                            </Whisper>
                          );
                        }
                        if (col === "Subscription Tier at Submission") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Subscription Tier at Submission</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Submission</th>
                            </Whisper>
                          );
                        }
                        if (col === "Subscription Tier Duration (Days)") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Subscription Tier Duration (Days)</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Subscription (Days)</th>
                            </Whisper>
                          );
                        }
                        if (col === "Platform Registration Date") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Platform Registration Date</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Registration Date</th>
                            </Whisper>
                          );
                        }
                        if (col === "Lead Owner (IR Rep)") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Lead Owner (IR Rep)</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",

                                }}>Lead Owner</th>
                            </Whisper>
                          );
                        }
                        if (col === "Lead Status") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: 'center',
                              }}>Lead Status</th>
                          );
                        }
                        if (col === "Priority Level") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Priority Level</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Priority</th>
                            </Whisper>
                          );
                        }
                        if (col === "IR Tags (Custom Labels)") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>IR Tags (Custom Labels)</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>IR Tags</th>
                            </Whisper>
                          );
                        }
                        if (col === "IR Notes") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>IR Notes</th>
                          );
                        }
                        if (col === "Contact History Log") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Contact History Log</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>History Log</th>
                            </Whisper>
                          );
                        }
                        if (col === "Last Contacted Date") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Last Contacted Date</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Last Contact</th>
                            </Whisper>
                          );
                        }
                        if (col === "Created At") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>Created On</th>
                          );
                        }
                        if (col === "Last Updated At") {
                          return (
                            <th
                              key={col}
                              draggable
                              onDragStart={(e) => handleDragStart(e, col)}
                              onDrop={(e) => handleDrop(e, col)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}>Last Updated</th>
                          );
                        }
                        if (col === "UTM Source") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>UTM Source</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Source</th>
                            </Whisper>
                          );
                        }
                        if (col === "UTM Campaign") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>UTM Campaign</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Campaign</th>
                            </Whisper>
                          );
                        }
                        if (col === "UTM Medium") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>UTM Medium</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: 'center',
                                }}>Medium</th>
                            </Whisper>
                          );
                        }
                        if (col === "Referral Code") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Referral Code</Tooltip>}>
                              <th
                                key={col}
                                draggable
                                onDragStart={(e) => handleDragStart(e, col)}
                                onDrop={(e) => handleDrop(e, col)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}>Referral</th>
                            </Whisper>
                          );
                        }

                        return null;
                      })}
                    </tr>
                  </thead>

                  <tbody>
                     {reportdata && reportdata.length === 0 ? (
                 <tr>
                        <td colSpan="14" style={{ textAlign: "center", fontSize: 20, paddingTop: 60, paddingBottom: 30 }}>
                          No data available
                        </td>
                      </tr>
              ) : (
                reportdata &&
                reportdata.map((item, index) => (
                    <tr >
                      {columnOrder.map((col) => {
                        if (col === "Waitlist ID") return <td key={col}>WL-{item.waitlist_id}</td>
                        if (col === "Full Name")
                          return (
                            <td key={col} style={{ fontWeight: 600 }} onClick={handleEditModalOpen}>
                              <div className="name__col_cell"><span>{item.name}</span></div>
                            </td>
                          );
                        if (col === "Email Address") return <td key={col} data-column-id={col}>{item.email}</td>;
                        if (col === "Phone Number") return <td key={col} style={{ fontWeight: 600 }} data-column-id={col}>{item.phone}</td>;
                        if (col === "Country of Residence") return <td key={col} style={{}} data-column-id={col}>
                         <div className="company_name_td">
                          {item.country ? (
                            <>
                              <div className="clogo">
                                <CircleFlag countryCode={item.countryCode?.toLowerCase()} style={{ width: 30, height: 30 }} />
                              </div>
                              {item.country}
                            </>
                          ) : (
                            <div className="clogo">-</div>
                          )}
                        </div>
                        </td>;
                          if (col === "Local Time") return <td key={col} data-column-id={col}>
                                                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{item.time_zone}</Tooltip>}>
                                                            <span><LiveTimeCell timezone={item.time_zone} /></span> 
                                                          </Whisper>
                                                        </td>;
                        if (col === "Preferred Language") return <td key={col} style={{}} data-column-id={col}>{item.language}</td>;
                        if (col === "Preferred Contact Method") return <td key={col} style={{ textAlign: 'center' }} data-column-id={col}><img src={ item.contact_method === 'phone' ? iconPhone : item.contact_method === 'whatsapp' ? iconWhatsapp : item.contact_method === 'email' ? iconMail : iconPhone } width="30" /></td>;
                        if (col === "Opt-In Consent") return <td style={{}} data-column-id={col}>{item.consent || "-"}</td>;
                        if (col === "Investment Interest Amount") return <td style={{ textAlign: 'center', fontWeight: 600 }} data-column-id={col}>{item.investment_amount || "-"}</td>;
                        if (col === "Estimated Investment Timeline") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.timeline || "-"}</td>;
                        if (col === "Accredited Investor Status") return <td style={{ textAlign: 'center' }} data-column-id={col}><span className={`tag_td ${item.accredited == 'Yes' ? 'halal_tag' : ''}`}>{item.accredited}</span></td>;
                        if (col === "Investor Type") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.investor_type || "-"}</td>;
                        if (col === "Investment Likelihood Score") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.likelihood_score || "-"}</td>;
                        if (col === "Platform User Match") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.user_match || "-"}</td>;
                        if (col === "App/Web Usage Detected") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.usage_detected || "-"}</td>;
                        if (col === "Subscription Tier at Submission") return <td style={{ textAlign: 'center' }} data-column-id={col}><span class="">{item.submission || "-"}</span></td>;
                        if (col === "Subscription Tier Duration (Days)") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.subscription_days || "-"}</td>;
                        if (col === "Platform Registration Date") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.register_date || "-"}</td>;
                        if (col === "Lead Owner (IR Rep)") return <td style={{ fontWeight: 600 }} data-column-id={col}>{item.lead_owner || "-"}</td>;
                        if (col === "Lead Status") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.lead_status || "-"}</td>;
                        if (col === "Priority Level") return <td style={{ textAlign: 'center' }} data-column-id={col}><span className='' style={{ maxWidth: 90 }}>{item.priority || "-"}</span></td>;
                        if (col === "IR Tags (Custom Labels)") return <td style={{}} data-column-id={col}>{item.ir_tags || "-"}</td>;
                        if (col === "IR Notes") return <td style={{}} data-column-id={col}>{item.ir_notes || "-"}</td>;
                        if (col === "Contact History Log") return <td style={{}} data-column-id={col}>{item.history_log || "-"}</td>;
                        if (col === "Last Contacted Date") return <td style={{}} data-column-id={col}>{item.last_contact || "-"}</td>;
                        if (col === "Created At") return <td style={{}} data-column-id={col}>{item.created_at || "-"}</td>;
                        if (col === "Last Updated At") return <td style={{}} data-column-id={col}>{item.updated_at || "-"}</td>;
                        if (col === "UTM Source") return <td style={{ textAlign: 'center' }} data-column-id={col}><img width="30" />{item.source || '-'}</td>;
                        if (col === "UTM Campaign") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.campaign || '-'}</td>;
                        if (col === "UTM Medium") return <td style={{ textAlign: 'center' }} data-column-id={col}>{item.medium || '-'}</td>;
                        if (col === "Referral Code") return <td key={col} data-column-id={col}>{item.referral_source || '-'}</td>;
                        return null;
                      })}
                    </tr>
))
              )}
          

                  </tbody>
                </table>

              </div>
              {reportCount > 1 && renderPagination()}
            </>
          )}
        </div>
      </div>

      <Modal open={EditModalOpen} onClose={handleEditModalClose}
        className="edit_status_modal modal_vflex_end slide-from-right"
        placement="right"
        transition
      >
        <Modal.Header className="edit_modal_header">
          <Modal.Title className="edit_modal_title">Update Waiting List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="edit_modal_content">
            <div className="edit_status_field">
              <div class="duplicate_form_row">
                <div class="duplicate_form_col">
                  <label>Phone Number</label>
                  <input type='text' placeholder='Enter Number' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Country of Residence</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Country Residence"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Preferred Language</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Language"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Opt-In Consent</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Opt-In Consent"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Inv. Int. Amount</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Int. Amount"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Est. Inv. Timeline</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Timeline"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Accredited Investor Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Acc. Inv. Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Investor Type</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Investor Type"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Investment Likelihood Score</label>
                  <input type='text' placeholder='Inv. Likelihood Score' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Lead Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Lead Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col" style={{ width: '100%' }}>
                  <label>IR Notes</label>
                  <textarea className='form-control' placeholder='Notes' rows={3} style={{ height: 'auto' }}></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal_footer_edit_status">
          <div className="btn__group">
            <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
            <button className="btn__save" onClick={handleManualSave}>Update</button>
          </div>
        </Modal.Footer>
      </Modal>

      <Drawer open={open2} onClose={handleCloseDrawer} size="xs" placement="left" className='show_hide_drawer'>
        <Drawer.Header>
          <Drawer.Title>Show & Hide Columns</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {/* Static Checkboxes */}
          <div style={{ marginTop: 30 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="Email"
                />
                <label
                  class="form-check-label"
                  htmlFor="Email"
                >
                  Email Address
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PhoneNumber"
                />
                <label
                  class="form-check-label"
                  htmlFor="PhoneNumber"
                >
                  Phone Number
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="CountryofResidence"
                />
                <label
                  class="form-check-label"
                  htmlFor="CountryofResidence"
                >
                  Country of Residence
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PreferredLanguage"
                />
                <label
                  class="form-check-label"
                  htmlFor="PreferredLanguage"
                >
                  Preferred Language
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PreferredContactMethod"
                />
                <label
                  class="form-check-label"
                  htmlFor="PreferredContactMethod"
                >
                  Preferred Contact Method
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="Opt-InConsent"
                />
                <label
                  class="form-check-label"
                  htmlFor="Opt-InConsent"
                >
                  Opt-In Consent
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="InvestmentInterestAmount"
                />
                <label
                  class="form-check-label"
                  htmlFor="InvestmentInterestAmount"
                >
                  Investment Interest Amount
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="EstimatedInvestmentTimeline"
                />
                <label
                  class="form-check-label"
                  htmlFor="EstimatedInvestmentTimeline"
                >
                  Estimated Investment Timeline
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="AccreditedInvestorStatus"
                />
                <label
                  class="form-check-label"
                  htmlFor="AccreditedInvestorStatus"
                >
                  Accredited Investor Status
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="InvestorType"
                />
                <label
                  class="form-check-label"
                  htmlFor="InvestorType"
                >
                  Investor Type
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="InvestmentLikelihoodScore"
                />
                <label
                  class="form-check-label"
                  htmlFor="InvestmentLikelihoodScore"
                >
                  Investment Likelihood Score
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PlatformUserMatch"
                />
                <label
                  class="form-check-label"
                  htmlFor="PlatformUserMatch"
                >
                  Platform User Match
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="App/WebUsageDetected"
                />
                <label
                  class="form-check-label"
                  htmlFor="App/WebUsageDetected"
                >
                  App/Web Usage Detected
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SubscriptionTierSubmission"
                />
                <label
                  class="form-check-label"
                  htmlFor="SubscriptionTierSubmission"
                >
                  Subscription Tier at Submission
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SubscriptionTierDuration"
                />
                <label
                  class="form-check-label"
                  htmlFor="SubscriptionTierDuration"
                >
                  Subscription Tier Duration (Days)
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PlatformRegistrationDate"
                />
                <label
                  class="form-check-label"
                  htmlFor="PlatformRegistrationDate"
                >
                  Platform Registration Date
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LeadOwner"
                />
                <label
                  class="form-check-label"
                  htmlFor="LeadOwner"
                >
                  Lead Owner (IR Rep)
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LeadStatus"
                />
                <label
                  class="form-check-label"
                  htmlFor="LeadStatus"
                >
                  Lead Status
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="PriorityLevel"
                />
                <label
                  class="form-check-label"
                  htmlFor="PriorityLevel"
                >
                  Priority Level
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IRTags"
                />
                <label
                  class="form-check-label"
                  htmlFor="IRTags"
                >
                  IR Tags (Custom Labels)
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IRNotes"
                />
                <label
                  class="form-check-label"
                  htmlFor="IRNotes"
                >
                  IR Notes
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="ContactHistoryLog"
                />
                <label
                  class="form-check-label"
                  htmlFor="ContactHistoryLog"
                >
                  Contact History Log
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LastContactedDate"
                />
                <label
                  class="form-check-label"
                  htmlFor="LastContactedDate"
                >
                  Last Contacted Date
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="CreatedAt"
                />
                <label
                  class="form-check-label"
                  htmlFor="CreatedAt"
                >
                  Created At
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="LastUpdatedAt"
                />
                <label
                  class="form-check-label"
                  htmlFor="LastUpdatedAt"
                >
                  Last Updated At
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="UTMSource"
                />
                <label
                  class="form-check-label"
                  htmlFor="UTMSource"
                >
                  UTM Source
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="UTMCampaign"
                />
                <label
                  class="form-check-label"
                  htmlFor="UTMCampaign"
                >
                  UTM Campaign
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="UTMMedium"
                />
                <label
                  class="form-check-label"
                  htmlFor="UTMMedium"
                >
                  UTM Medium
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="ReferralCode"
                />
                <label
                  class="form-check-label"
                  htmlFor="ReferralCode"
                >
                  Referral Code
                </label>
              </div>
            </div>
          </div>
        </Drawer.Body>
        <Drawer.Footer>
          <Button className="btn__cancel" style={{ width: '100%', background: '#FFF' }}>Reset</Button>
        </Drawer.Footer>
      </Drawer>

    </>
  );
}

export default WaitingList;
